import React from 'react';
import PropTypes from 'prop-types';
import styles from './Richtext.module.scss';

const Richtext = (props) => {
    return (
        <div className={`${styles.richtext} ${props.additionalClass ? props.additionalClass : '' }`}>
            {props.children}
        </div>
    )
};

Richtext.propTypes = {
    children: PropTypes.node,
    additionalClass: PropTypes.string,
}

export default Richtext;